import * as React from "react"
import "./learn_more.scss";
import {useState} from "react";

export default function PPLearnMoreBlock({learnMore, learnMoreIcon}) {
    const [showFullInfo, setShowFullInfo] = useState(false);
    const urlStringParser = (stringData) => {
        return (stringData || '').replace(/\bhttps?:\/\/\S+/gi, '<a href="$&" target="_blank" rel="nofollow">$&</a>');
    }
    return (
        <div className={`learn-more-block-wrapper`}>
            <div className={`text-content  ${showFullInfo ? 'expand' : ''}`}>
                {learnMoreIcon && (
                    <div className={`learn-more-icon`}>
                        <img src={learnMoreIcon} alt=""/>
                    </div>
                )}

                <p dangerouslySetInnerHTML={{__html: urlStringParser(learnMore)}}/>
            </div>
            <a
                onClick={() => {
                    setShowFullInfo(!showFullInfo)
                }}
                className={`show-full-info-action`}>
                {showFullInfo ? 'View Less' : 'Learn More'}
            </a>
        </div>
    )
}
